import React from "react";
import TabItem from "../TabItem/TabItem";
import * as St from "./styles";

export type TipoCartao = "cartaoAtual" | "cartaoAtualConvenio" | "valeCompras";

export interface OpcaoCartao {
    value: TipoCartao;
    label: string;
    disabled?: boolean;
}

interface CardsTabProps {
    opcoes: OpcaoCartao[];
    valorAtivo: TipoCartao;
    aoMudar: (valor: TipoCartao) => void;
}

const CardsTab: React.FC<CardsTabProps> = ({
    opcoes,
    valorAtivo,
    aoMudar,
}) => {
    return (
        <St.Container>
            {opcoes.map((opcao) => (
                <TabItem
                    key={opcao.value}
                    label={opcao.label}
                    flexGrow={Math.max(opcao.label.length, 1)}
                    isActive={valorAtivo === opcao.value}
                    disabled={opcao.disabled}
                    onClick={() => {
                        if (!opcao.disabled) {
                            aoMudar(opcao.value);
                        }
                    }
                    }
                />
            ))}
        </St.Container>
    );
};

export default CardsTab;
